import { string, object } from 'yup'

export const authorizationDataSchema = object({
  websocketURL: string().required(),
  token: string().required(),
})
